import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { UrlService } from '@core/services/url/url.service';


import * as fromAppState from '@app/store/state/app/app.state';
import * as fromAppActions from '@app/store/state/app/app.actions';
import { AppStatus } from 'app/store/state/app/app.state';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    static readonly HTTP_ERROR_NOT_LOGGED = 401;
    static readonly HTTP_ERROR_TOO_MANY_CONNECTIONS = 509;

    protected httpError =  new EventEmitter<number>();

    //protected logged =  new EventEmitter<boolean>();
    protected disabled = new EventEmitter<boolean>();

    protected version = new EventEmitter<string>();


    constructor(private router:Router, private urlSrv : UrlService, private store: Store<fromAppState.App>, protected http: HttpClient) {
        this.urlSrv.setPrefix("/web/app");
        this.urlSrv.setPublicPrefix("/web");
    }

    public init() {
        this.store.dispatch(new fromAppActions.LoadSessionRequest());
    }

    public getSession() {
        return this.store.select(fromAppState.appSessionSelector);
    }

    public getAccountSession() {
        return this.store.select(fromAppState.appAccountSessionSelector);
    }

    public getAllowedApps() {
        return this.store.select(fromAppState.appAllowedAppsSelector);
    }

    /**
     * Whether the current organization has access to this app.
     * @returns an observable of `null` while unresolved, otherwise `true`/`false`
     */
    public getAppAccess() {
        return this.store.select(fromAppState.appHasAccessSelector);
    }

    public getAccess = (key: string) : Observable<string | boolean> => this.store.select(fromAppState.appAccessSelector(key));

    public selectApp() {
        return this.store.select(fromAppState.appSelector);
    }

    public setHttpError(code: number) {
        this.httpError.emit(code);
    }

    public getHttpError() {
        return this.httpError;
    }

    public changeOrganization(newOrg) {
        this.store.dispatch(new fromAppActions.ChangeOrganization(newOrg));
    }

    // @deprecated
    // public setLogged(logged: boolean) {
    //     this.logged.emit(logged);
    // }
    //
    // public getLogged() {
    //     return this.logged;
    // }

    public setDisable(disabled: boolean){
        this.disabled.emit(disabled);
    }

    public getDisable(){
        return this.disabled;
    }

    // Version
    public getVersion(){
        return this.store.select(fromAppState.appVersionSelector);
    }

    public setVersion(version: string){
        this.store.dispatch(new fromAppActions.SetVersion(version));
    }

    public getStatus() : Observable<AppStatus> {
        return this.store.select(fromAppState.appStatusSelector);
    }

    public disconnect() {
        this.store.dispatch(new fromAppActions.Disconnected());
    }

    public updateUser(name: string){
        this.store.dispatch(new fromAppActions.UpdateUser(name));
    }

    public resetPassword(email : string): Observable<HttpResponse<any>> {
        let url = this.urlSrv.buildLogin("/passwords")
        let options = { headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};
        // Payload for the post call
        const payload = { 
            device: navigator.userAgent || 'unknown',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
            email: email
        };
        // Post call without body
        return this.http.post<HttpResponse<any>>(url, payload, options);
    }

}
